var $30cee8d2535734ec$exports = {};
$30cee8d2535734ec$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};


export {$30cee8d2535734ec$exports as default};
//# sourceMappingURL=da-DK.module.js.map
